import {Component} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-account-tabs',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    TranslocoPipe,
  ],
  templateUrl: './account-tabs.component.html',
  styleUrl: './account-tabs.component.scss'
})
export class AccountTabsComponent {}
